import { render, staticRenderFns } from "./comment-item.vue?vue&type=template&id=546d6f2e&scoped=true&"
import script from "./comment-item.vue?vue&type=script&lang=js&"
export * from "./comment-item.vue?vue&type=script&lang=js&"
import style0 from "./comment-item.vue?vue&type=style&index=0&id=546d6f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d6f2e",
  null
  
)

export default component.exports